<script setup>
import { i18n } from 'boot/i18n';
import { BEHAVIOR_TRACKING_ICON } from 'src/constants/programs';
import { HrIcon, HrTooltip } from 'src/design-system';
import { computed } from 'vue';

/**
 * Marks a Behavior Tracking program where program types are listed together, so the
 * type is readable without opening the program. Callers render it only for that type.
 */
const props = defineProps({
  /** Matches the icon to the text it sits beside — see `HrIcon` for the scale. */
  size: {
    type: String,
    default: 'sm',
  },
});

// HrIcon applies its size tokens only under the design-system theme; the legacy theme needs a Quasar size.
const LEGACY_SIZES = { xxs: '12px', xs: '16px', sm: '18px', md: '24px', lg: '32px', xl: '48px' };

const legacyProps = computed(() => ({ size: LEGACY_SIZES[props.size] }));

const label = computed(() => i18n.t('programType_behaviorTracking'));
</script>

<template>
  <hr-icon
    :name="BEHAVIOR_TRACKING_ICON"
    :size="size"
    :legacy-props="legacyProps"
    class="q-mr-xs"
    role="img"
    :aria-label="label"
    data-e2e="icon-program-type-behavior-tracking"
  >
    <hr-tooltip>{{ label }}</hr-tooltip>
  </hr-icon>
</template>
